import React, { Component } from 'react';
import { ButtonGroup, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import i18n from './Localization';
import { TOOLTIP_DELAY } from './Xword';

const OPTIONS = [
  { key: "1", value: i18n.t("printOption01") },
  // { key: "3", value: i18n.t("printOption03") },   //disabled option 3 because the filled in letters are not sent to the server
  { key: "2", value: i18n.t("printOption02") },
  { key: "4", value: i18n.t("printOption04") },
]

class PrintButton extends Component {
  constructor() {
    super();
    this.state = {
      selected: "1",
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({show_modal: true});
    window.addEventListener("keydown", this.onKeyDown);
  }

  close() {
    this.setState({show_modal: false});
    window.removeEventListener("keydown", this.onKeyDown);
  }

  print() {
    const sel = Number.parseInt(this.state.selected)
    this.props.onSelect(sel);
    this.close();
  }

  getNext = () => {
    switch (this.state.selected) {
      case "1":
        return "2"
      case "2":
        return "4"
      case "4":
        return "1"
    }
  }

  getPrev = () => {
    switch (this.state.selected) {
      case "1":
        return "4"
      case "2":
        return "1"
      case "4":
        return "2"
    }
  }

  onKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown":
        const next = this.getNext()
        this.setState({ selected: next })
        break;
      case "ArrowUp":
        const prev = this.getPrev()
        this.setState({ selected: prev })
        break;
      case "Enter":
        this.print();
        break;
    }
  }

  render() {
    const options = OPTIONS.map(option => 
      <Form.Check 
        key={option.key} 
        id={option.key} 
        value={option.key}
        type="radio" 
        name="print" 
        label={option.value}
        checked={this.state.selected === option.key}
        onChange={e => this.setState({ selected: e.target.value })}
      />
    )

    return (
      <ButtonGroup>
        <OverlayTrigger delay={TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("printTooltip")}</Tooltip>}>
          <Button variant="light" className={"xwordjs-print-button"} size="sm" onClick={this.open}>
            <i className="icon fa fa-print" />
          </Button>
        </OverlayTrigger>

        <Modal show={this.state.show_modal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t("printTitle")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="xwordjs-print-menu">
              {i18n.t("printDescription")}
              <Form>
                {options}
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.print()}>Print</Button>
          </Modal.Footer>
        </Modal>
      </ButtonGroup>);
  }
}

export default PrintButton;
